// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"77ab36e7","541":"4d9bd963"}[chunkId] + ".chunk.css";
};